<template>
  <div class="wrapper">
    <div class="page-header page-header-mini"></div>
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <img class="d-block img-raised" :src="firstProduct.cover.path" />
          </div>
          <div class="col-md-6 ml-auto mr-auto">
            <h4 class="title">{{ firstProduct.name }}</h4>
            <p class="category">品牌類別：{{ firstProduct.brand.name }}</p>
            <p class="category">商品內容：</p>
            <p class="category">{{ firstProduct.summary }}</p>

            <p class="main-price">{{ firstProduct.price }}</p>

            <!-- <div class="row pick-size">
              <div class="col-lg-4 col-md-4 col-sm-4">
                <label>規格</label>
                <br />
                <el-select
                  v-model="filters.color"
                  class="select-info"
                  placeholder="請選擇"
                >
                  <el-option
                    class="select-default"
                    value="1"
                    label="黑"
                  ></el-option>
                  <el-option
                    class="select-default"
                    value="2"
                    label="白"
                  ></el-option>
                  <el-option
                    class="select-default"
                    value="3"
                    label="紅"
                  ></el-option>
                </el-select>
              </div>
            </div>-->
            <div class="row justify-content-start">
              <a :href="product_Link">
                <n-button type="info" class="mr-3 test">
                  <i class="now-ui-icons shopping_cart-simple"></i>
                  &nbsp; 下單
                </n-button>
              </a>
            </div>
          </div>
          <div class="col-md-12 ml-auto col-xl-12 mr-auto">
            <card class="tab">
              <tabs
                slot="raw-content"
                tab-content-classes="tab-content-padding text-center"
                type="info"
              >
                <tab-pane>
                  <template slot="label">商品說明</template>
                  <div class="description" v-html="firstProduct.description"></div>
                </tab-pane>
                <tab-pane>
                  <template slot="label">購物須知</template>
                  <div class="notice" v-html="firstProduct.notice"></div>
                </tab-pane>
              </tabs>
            </card>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer footer-big footer-white">
      <div class="container">
        <hr />
        <div class="row justify-content-end">
          <div class="copyright" style="margin-right: 15px;">
            Copyright &copy;
            {{ year }} by JS-Coder
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import {
  Card,
  Button,
  Collapse,
  CollapseItem,
  Tabs,
  TabPane
} from "@/components";
import { Carousel, CarouselItem, Select, Option, Tooltip } from "element-ui";
import gql from "graphql-tag";

export default {
  name: "product-page",
  bodyClass: "product-page",
  components: {
    Card,
    Collapse,
    CollapseItem,
    Tabs,
    TabPane,
    [Button.name]: Button,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip
  },
  data() {
    return {
      product: [],
      filters: {
        color: "",
        size: ""
      },
      year: new Date().getFullYear()
    };
  },
  computed: {
    firstProduct() {
      return (this.product || [])[0] || { brand: {}, cover: {} };
    },
    happyfan7_query() {
      return Object.keys(this.$route.query).reduce((queryStr, queryName) => {
        queryStr += `&${queryName}=${this.$route.query[queryName]}`;
        return queryStr;
      }, "");
    },
    product_Link() {
      return (
        `https://www.happyfan7.com/Public/Shopping/ProductView?productId=${this.firstProduct.happyfan7_product_id}${this.happyfan7_query}` ||
        ""
      );
    }
  },
  apollo: {
    product: {
      query: gql`
        query senddata($product_id: Int) {
          product(product_id: $product_id) {
            product_id
            name
            happyfan7_product_id
            summary
            description
            notice
            cover {
              file_id
              path
            }
            category {
              name
            }
            brand {
              name
            }
          }
        }
      `,
      variables() {
        return {
          product_id: parseInt(this.$route.params.product_id)
        };
      }
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.test {
  margin: 0 30px 0 30px;
}

.description {
  margin: 20px 50px 20px 50px;
}

.notice {
  margin: 20px 50px 20px 50px;
  text-align: left;
}

.tab {
  margin: 40px 0 0 0;
}

.page-header:before {
  background: -webkit-linear-gradient(left top, white, #fedfe1);
  background: -o-linear-gradient(bottom right, white, #fedfe1);
  background: -moz-linear-gradient(bottom right, white, #fedfe1);
  background: linear-gradient(to bottom right, white, #fedfe1);
}

.page-header-mini {
  min-height: 100px !important;
  max-height: 10px;
}

@media screen and (max-width: 600px) {
  .title {
    font-size: 1.3em;
  }
  .description {
    margin: 10px 10px 10px 10px;
  }
  .category {
    font-size: 1.3em;
  }
  .page-header-mini {
    min-height: 120px !important;
    max-height: 10px;
  }
}
</style>
